import React from 'react';
import CollapsiblePanel from '../../utils/CollapsiblePanel';
import ToggleRefinement from '../ToggleRefinement';
export default function ToggleRefinementPanel({ results, toggleRefinement, toggleRefinementSettings, additionalData, }) {
    const { canRefine } = toggleRefinement;
    const { panelSettings } = toggleRefinementSettings;
    if ((panelSettings === null || panelSettings === void 0 ? void 0 : panelSettings.hideIfEmpty) && !canRefine) {
        return null;
    }
    return (React.createElement(CollapsiblePanel, { collapsiblePanelSettings: panelSettings === null || panelSettings === void 0 ? void 0 : panelSettings.collapsiblePanelSettings, header: panelSettings === null || panelSettings === void 0 ? void 0 : panelSettings.header, footer: panelSettings === null || panelSettings === void 0 ? void 0 : panelSettings.footer },
        React.createElement(ToggleRefinement, { results: results, toggleRefinement: toggleRefinement, toggleRefinementSettings: toggleRefinementSettings, additionalData: additionalData })));
}
